export default "__VITE_ASSET__DbnzjkSL__"